import styled from "styled-components";

const ModalFormContainer = styled.form`
    padding: 16px;
    display: flex;
    flex-direction: column;
`;

export default ModalFormContainer;
